<template>
    <b-icon v-if="Value !== null && Value !== undefined" icon="circle-fill" class="w-100"
            :variant="Value !== Header.TrueValue ? 'danger' : 'success'"/>
</template>

<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import {HeaderBoolean} from "@/components/commons/Generics/GenericTable/GenericTableHeader";

@Component({})
export default class GenericTableBooleanCell extends Vue {
    /** Valeur */
    @Prop({default: () => false})
    public Value!: boolean;

    @Prop()
    public Header!: HeaderBoolean;
}
</script>
<style scoped>

</style>